<template>
    <b-modal :visible="visible" no-close-on-backdrop no-close-on-esc centered body-class="location-list-body">
        <div slot="modal-header" class="w-100">
            <h5>Select Locations
                <button type="button" class="close"
                        @click.prevent="closeModal()">
                    <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <div>
            <b-form-group>
                <b-form-radio-group v-model="filterByLocation"
                                    :options="filterOptions"
                                    stacked
                                    name="filterOption">
                </b-form-radio-group>
            </b-form-group>
            <transition name="slide">
              <b-form-group v-show="filterByLocation">
                <b-form-checkbox
                    v-model="allSelected"
                    @change="toggleAll"
                >
                  {{ allSelected ? 'Un-select All' : 'Select All' }}
                </b-form-checkbox>
                  <b-form-checkbox
                      v-for="location in locations" :key="location.locationId"
                      :id="'location-' + location.locationId"
                      v-model="locationIds"
                      :value="location.locationId"
                      class="ml-4"
                      stacked
                  >{{ location.name }}
                  </b-form-checkbox>
              </b-form-group>
            </transition>
        </div>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="saveLocationIds()">Save</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'location-select',

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      selectedLocationIds: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        locationIds: _.clone(this.selectedLocationIds),
        filterByLocation: this.selectedLocationIds.length > 0,
        allSelected: false,
        filterOptions: [
          { text: 'All Locations', value: false },
          { text: 'Select Locations', value: true }
        ]
      }
    },

    watch: {
      selectedLocationIds (newValue) {
        this.locationIds = _.clone(newValue)
        if (newValue.length === 0) {
          this.allSelected = false
        } else if (newValue === this.allLocationIds) {
          this.allSelected = true
        } else {
          this.allSelected = false
        }
      }
    },

    computed: {
      locations () {
        return this.$store.organization.locations
      },
      allLocationIds () {
        return this.locations.map(aLocation => {
          return aLocation.locationId
        })
      }
    },

    methods: {
      toggleAll (checked) {
        this.locationIds = checked ? this.allLocationIds : []
      },
      saveLocationIds () {
        if (this.filterByLocation) {
          this.$emit('saveLocationIds', this.locationIds)
        } else {
          this.locationIds = []
          this.$emit('saveLocationIds', [])
        }
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
